// src/config/billing.ts
import type { Appearance, StripeElementLocale } from "@stripe/stripe-js";

interface StripeConfig {
  publicKey: string;
  clientSecret: string;
  options: {
    locale: StripeElementLocale;
    appearance: Appearance;
    clientSecret: string;
  };
}

export const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY || "";
export const STRIPE_CLIENT_SECRET =
  process.env.REACT_APP_STRIPE_CLIENT_SECRET || "";

if (!STRIPE_PUBLIC_KEY) {
  console.error("Missing Stripe public key");
}

if (!STRIPE_CLIENT_SECRET) {
  console.error("Missing Stripe client secret");
}

export const stripeConfig: StripeConfig = {
  publicKey: STRIPE_PUBLIC_KEY,
  clientSecret: STRIPE_CLIENT_SECRET,
  options: {
    locale: "en" as StripeElementLocale,
    appearance: {
      theme: "stripe",
      variables: {
        colorPrimary: "#0070f3",
      },
    },
    clientSecret: STRIPE_CLIENT_SECRET,
  },
};
